(() => {
    const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
    const themeToggleBtn = document.getElementById('theme-toggle');

    if (!themeToggleDarkIcon || !themeToggleLightIcon || !themeToggleBtn) {
        return;
    }

    // Change the icons inside the button based on previous settings
    if (
        localStorage.getItem('color-theme') === 'dark' ||
        (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
        themeToggleLightIcon.classList.remove('hidden');
    } else {
        themeToggleDarkIcon.classList.remove('hidden');
    }

    let event = new Event('dark-mode');

    /**
     * Hold every colour transition still while the theme is swapped.
     *
     * `.dark` on <html> changes the colour of most of the page at once, and
     * anything with a transition on those properties animates its way across -
     * so the switch reads as the page repainting rather than as a setting being
     * applied. The rule lives in style.css; this puts the class on for the one
     * frame the swap takes.
     *
     * The reflow between adding the class and running `swap` is what makes it
     * work: without it the browser coalesces both style changes into a single
     * recalculation and the suppression is never observed. Two frames are
     * waited before it comes off, because the new colours are only settled once
     * the frame they were painted in has been committed.
     */
    function withoutTransitions(swap) {
        const root = document.documentElement;
        root.classList.add('theme-switching');
        void root.offsetHeight;
        swap();
        window.requestAnimationFrame(function() {
            window.requestAnimationFrame(function() {
                root.classList.remove('theme-switching');
            });
        });
    }

    themeToggleBtn.addEventListener('click', function() {
        // toggle icons
        themeToggleDarkIcon.classList.toggle('hidden');
        themeToggleLightIcon.classList.toggle('hidden');

        withoutTransitions(function() {
            // if set via local storage previously
            if (localStorage.getItem('color-theme')) {
                if (localStorage.getItem('color-theme') === 'light') {
                    document.documentElement.classList.add('dark');
                    localStorage.setItem('color-theme', 'dark');
                } else {
                    document.documentElement.classList.remove('dark');
                    localStorage.setItem('color-theme', 'light');
                }
            // if NOT set via local storage previously
            } else {
                if (document.documentElement.classList.contains('dark')) {
                    document.documentElement.classList.remove('dark');
                    localStorage.setItem('color-theme', 'light');
                } else {
                    document.documentElement.classList.add('dark');
                    localStorage.setItem('color-theme', 'dark');
                }
            }
        });

        document.dispatchEvent(event);
    });
})();
